import { LayoutService } from './../layout.service';
import { Field, FieldDataType } from './../../models/module-structure';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ModuleStructure } from 'src/app/models/module-structure';
import {
  SectionTableFilter,
  SectionTableFilterTypes,
} from 'src/app/models/section-table-filter';
import * as g from '../../globals';
import { RecordPageComponent } from '../record-page/record-page.component';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { Action } from '../record-model';
import { ModuleInformation } from 'src/app/models/module-information';
import * as moment from 'moment';
import { NzImage, NzImageService } from 'ng-zorro-antd/image';
import { format } from 'date-fns';
import { NzMessageService } from 'ng-zorro-antd/message';
import { forkJoin } from 'rxjs';
@Component({
  selector: 'app-records-list-table',
  templateUrl: './records-list-table.component.html',
  styleUrls: ['./records-list-table.component.less'],
})
export class RecordsListTableComponent implements OnInit {
  FieldDataType = FieldDataType;
  @Input() moduleStructure: ModuleStructure;
  @Input() listOfRecords: any;
  @Input() isLoading = true;
  @Input() selectedRecords: string[] = [];
  @Input() selectedRecordsFromCheckBox: string[] = [];
  @Input() pageSize: number;
  @Input() showCheckBoxInTableMode = false;
  @Input() keyName = 'KEY';
  @Input() moduleActions: Action[];
  @Input() moduleInformation: ModuleInformation;
  @Input() inModuleList = false;
  @Input() fromDraft = false;
  global = g;

  sortedFields: Field[];
  @Input() set fields(value: Field[]) {
    this.sortedFields = value.sort(
      (a, b) => a.InTableSortOrder - b.InTableSortOrder
    );
  }

  get fields() {
    return this.sortedFields;
  }

  @Output() selectRecord = new EventEmitter<any>();
  @Output() selectRecordFromCheckBox = new EventEmitter<any>();
  @Output() sortChanged = new EventEmitter();

  @Input() sortedByDir: string;
  @Output() sortedByDirChange: EventEmitter<string> = new EventEmitter();

  @Input() sortedByField: number;
  @Output() sortedByFieldChange: EventEmitter<number> = new EventEmitter();

  @Input() customActions: { label: string; key: string }[];
  @Output() customActionClicked = new EventEmitter<{
    key: string;
    value: any;
  }>();

  pageSizeArray: number[] = [];
  dateFormat = g.companyConfiguration.DateFormat;

  @Input() filters: { [key: string]: SectionTableFilter };
  @Output() filtersChange = new EventEmitter<{
    [key: string]: SectionTableFilter;
  }>();
  constructor(
    private layoutService: LayoutService,
    private drawerService: NzDrawerService,
    private nzImageService: NzImageService,
    private messageService: NzMessageService,

  ) { }
  // @Input() allowEditable: boolean = false;
  ngOnInit(): void {
    /*
    this.fields.forEach((col) => {
      this.filters[col.Name] = {
        valueFrom: null,
        valueTo: null,
        singleValue: null,
        filterType: SectionTableFilter.getFilterType(col.Type),
      };
    });
    */
    
    this.allowEditable = this.global.allowBulkEdit;

  }
  // ngOnChanges(changes: SimpleChanges): void {
  //   if (changes['listOfRecords']) {
  //     const newValue = changes['listOfRecords'].currentValue;

  //     console.log('List of records has changed:', newValue);


  //     if (newValue && newValue.table && Array.isArray(newValue.table.rowsArray)) {
  //       this.listOfRecords = newValue.table.rowsArray;
  //     } else {
  //       this.listOfRecords = [];
  //     }
  //     console.log('list B : ',this.listOfRecords);
  //   }
  // }
  openRecordPage(
    field: import('src/app/models/module-structure').Field,
    value: any
  ) {
    this.layoutService.moduleIdByType(field.LinkedModule).subscribe((d) => {
      RecordPageComponent.openRecordPage(this.drawerService, {
        actionType: 'View',
        drawerTitle: 'View Details',
        inDrawer: true,
        moduleId: Number(field.LinkedModule),
        parentComponent: this,
        recordId: value,
        recordModel: undefined,
      });
    });
  }

  getOptions(field: import('src/app/models/module-structure').Field) {
    let queryId = field.SQLStatementId;
    if (
      field.FilterSQLStatementId != null &&
      field.FilterSQLStatementId !== 0
    ) {
      queryId = field.FilterSQLStatementId;
    }

    // const paramsNames = g.queriesData[queryId];
    // const vals: string[] = [];

    this.layoutService
      .getSelectValues(
        this.moduleStructure,
        field.AdditionalInformationParsed.DataSourcePath,
        field.Id,
        queryId,
        [],
        []
      )
      .subscribe((d: any) => {
        field.Options = d.Values.rowsArray;
      });
  }

  changeSorting(i: number, direction: string) {
    if (direction === null) {
      return;
    }

    this.sortedByFieldChange.emit(i);
    if (direction === 'ascend') {
      this.sortedByDirChange.emit('ASC');
    } else {
      this.sortedByDirChange.emit('DESC');
    }

    this.sortChanged.emit();
  }

  rowSelectedFromCheckBox(data, event) {
    if (this.inModuleList) {
      this.selectRecordFromCheckBox.emit({ data, event });
    } else {
      if (event) {
        this.selectRecord.emit(data);
      } else {
        // it was undefined
        this.selectRecord.emit(data);
      }
    }
  }

  rowSelected(data): void {
    
    if (
      !(
        data['U_ITM_ACTIVE'] == null ||
        data['U_ITM_ACTIVE'] === undefined ||
        data['U_ITM_ACTIVE'] === 'true'
      )
    ) {
      return;
    }
    this.selectRecord.emit(data);
  }
  adjustDateVals(filterField: any): void {
    if (filterField.valueTo !== null) {
      filterField.valueTo = moment(new Date(filterField.valueTo)).format(
        'yyyy-MM-DD'
      );
    }
    if (filterField.valueFrom !== null) {
      filterField.valueFrom = moment(new Date(filterField.valueFrom)).format(
        'yyyy-MM-DD'
      );
    }
    if (filterField.singleValue !== null) {
      filterField.singleValue = moment(
        new Date(filterField.singleValue)
      ).format('yyyy-MM-DD');
    }
  }
  updateFilter(): void {
    this.filtersChange.emit(this.filters);
  }

  keyup($event: any) {
    if ($event.key === 'Enter' || $event.key === 'Tab') {
      this.updateFilter();
    }
  }

  previewImage(data, field: Field) {
    if (!field.AdditionalInformationParsed.IsImage) {
      this.rowSelected(data);
      return;
    }
    let image = data[field.FieldName];
    let activeIndex = 0;
    let file = '';
    let images = [];
    let isVisible = false;

    if (image.indexOf(';') != -1) {
      file = '';
      images = image.split(';');
      let _images = images.map((image: string) => {
        if (image != null && image !== undefined && image.trim() !== '') {
          const img: NzImage = {
            src: `${g.apiBaseUrl
              }media/PreviewFile?path=${image}&${g.getUrlSuffix()}`,
            width: '50vw',
            height: 'auto',
            alt: 'ng-zorro',
          };
          return img;
        }
      });
      _images = _images.filter((image) => image != null);
      this.nzImageService.preview(_images, { nzZoom: 1.5, nzRotate: 0 });
    } else {
      images = [];
      file = image;
      isVisible = true;
      const _images = [
        {
          src: `${g.apiBaseUrl
            }media/PreviewFile?path=${image}&${g.getUrlSuffix()}`,
          width: '50vw',
          height: 'auto',
          alt: 'ng-zorro',
        },
      ];
      this.nzImageService.preview(_images, { nzZoom: 1.5, nzRotate: 0 });
    }
  }

  removeSpaces(input): string {
    return input?.toString().replace(/[^a-zA-Z0-9-_]/g, '');
  }

  // EditableInList
  allowEditable: boolean = true;
  editingCells: { [key: string]: boolean } = {};
  selectedForEdit: any[] = [];
  allSelected: boolean = false;
  @Output() selectedItemsChange = new EventEmitter<any[]>();
  @Output() submitClicked = new EventEmitter<void>();
  @Input() selectedItem: any[] = [];

  newValue: { [key: string]: any } = {};
  field: Field;
  value: any;
  isLoadingDrawer = false;
  visible = false;


  getCellKey(data: any, field: any): string {
    return `${data.Row}_${field.FieldName}`;;
  }

  enableEdit(data: any, field: any) {
    const key = this.getCellKey(data, field);
    this.editingCells[key] = true;
  }

  disableEdit(
    data: any, newFiled: any, field: Field) {

    const key = this.getCellKey(data, field);

    if (field.DataType === FieldDataType.Date) {
      const parsedDate = new Date(newFiled);
      if (!isNaN(parsedDate.getTime())) {
        newFiled = format(parsedDate, 'yyyy/MM/dd');
      }
    }

    data[field.FieldName] = newFiled;

    this.editingCells[key] = false;
    this.layoutService.modifyModuleField(field.Id, data.KEY, newFiled).subscribe({
      next: () => {
        this.messageService.success('Update successful');
        data.selected = false;
        this.selectedForEdit = this.selectedForEdit.filter(item => item !== data);
        //this.selectedItemsChange.emit(this.selectedForEdit);
      },

      error: () => this.messageService.error('An error occurred during the update')
    });
  }
    submit(): void {
    this.isLoadingDrawer = true;

    this.value = this.newValue[this.field.PropertyName];

    if (this.field.DataType === FieldDataType.Date) {
      const parsedDate = new Date(this.value);
      if (!isNaN(parsedDate.getTime())) {
        this.value = format(parsedDate, 'yyyy/MM/dd');
      }
    }


    const requests = this.selectedForEdit.map(item =>
      this.layoutService.modifyModuleField(this.field.Id, item.KEY, this.value)
    );


    forkJoin(requests).subscribe({
      next: (responses) => {

        this.selectedForEdit.forEach(item => item.selected = false);
        this.selectedForEdit = [];
        this.submitClicked.emit();
        this.visible = false;
      },
      error: (err) => {
        this.messageService.error('An error occurred while updating some records');
        this.isLoadingDrawer = false;
      },
      complete: () => {
        this.messageService.success('All records updated successfully');
        this.isLoadingDrawer = false;
      }
    });
  }


  checkboxChange(record: any) {
    if (record.selected) {
      if (!this.selectedForEdit.includes(record)) {
        this.selectedForEdit.push(record);
      }
    } else {
      this.selectedForEdit = this.selectedForEdit.filter(r => r !== record);
    }
    this.selectedItemsChange.emit(this.selectedForEdit);

  }

selectAll(checked: boolean) {
  this.allSelected = checked;
  if (this.listOfRecords?.table?.rowsArray) {
    this.listOfRecords.table.rowsArray.forEach((record: any) => {
      record.selected = checked;
      if (checked && !this.selectedForEdit.includes(record)) {
        this.selectedForEdit.push(record);
      } else if (!checked) {
        this.selectedForEdit = this.selectedForEdit.filter(r => r !== record);
      }
    });
  }
  this.selectedItemsChange.emit(this.selectedForEdit);
}

  openDrawer(): void {
    this.visible = true;
    this.newValue = {};
  }

  closeDrawer(): void {
    this.visible = false;
  }

  onFieldValueChange(field: any) {
    this.field = field;
  }


getOptionLabel(field: any, value: string): string {
  const matchedOption = field.Options?.find((option: any) =>
    (option.DBValue?.toString() ?? option.Code?.toString()) === value?.toString()
  );
  if (!matchedOption) return value;

  return matchedOption.Name

}

}
